export default __webpack_public_path__ + "dashboard_disarmed.1edd8427.png";